<div class="wrap">
  <app-header></app-header>
  <div class="main-holder">
    <app-nav></app-nav>
    <div class="main">
      <div class="main-content">
        <div class="bread">
          <ol>
            <li><a [routerLink]="['/']"><img src="../../../../assets/okito/images/icons/home.svg" alt="Home"></a></li>
            <img src="../../../../assets/okito/images/icons/chevron-right.svg" alt="">
            <li><span>Taxi Fleet Management</span></li>
          </ol>
        </div>
        <div class="content-title">
          <h2>Taxi Fleet Management</h2>
          <p>Manage Taxi Fleet operators and partners</p>
        </div>
        <hr>

        <div class="cards">
          <div class="row">
            <div class="col-md">
              <div class="card-item">
                <div class="card-content">
                  <small>Total Fleet Operators</small>
                  <h4>{{ summaryStats.totalOperators }}</h4>
                </div>
                <img src="../../../../assets/okito/images/card-icons/partner.svg" alt="">
              </div>
            </div>
            <div class="col-md">
              <div class="card-item">
                <div class="card-content">
                  <small>Active Vehicles</small>
                  <h4>{{ summaryStats.totalVehicles }}</h4>
                </div>
                <img src="../../../../assets/okito/images/card-icons/suv.svg" alt="">
              </div>
            </div>
            <div class="col-md">
              <div class="card-item">
                <div class="card-content">
                  <small>Active Drivers</small>
                  <h4>{{ summaryStats.activeDrivers }} / {{ summaryStats.totalDrivers }}</h4>
                </div>
                <img src="../../../../assets/okito/images/card-icons/supply.svg" alt="">
              </div>
            </div>
          </div>
        </div>

        <div class="list-holder">
          <div class="tools">
            <div class="list-title">
              <h4>Taxi Fleet Operators</h4>
            </div>
            <div class="search mg-right-auto">
              <img src="../../../../assets/okito/images/icons/magnifying.svg" alt="">
              <input
                type="text"
                class="text-search"
                placeholder="Search"
                [(ngModel)]="searchKeyword"
                (ngModelChange)="onSearchChange()"
              >
            </div>
            <div class="actions">
              <select
                class="sort-select"
                aria-label="Sort order"
                [(ngModel)]="sortOrder"
                (ngModelChange)="onSortChange()">
                <option value="asc">Ascending</option>
                <option value="desc">Descending</option>
              </select>
              <a [routerLink]="['/admin/taxi-fleet/create']" class="btn btn-sm btn-default">Add Taxi Fleet Operator</a>
            </div>
          </div>
          <div class="list-tabs">
            <ul>
              <li *ngFor="let tab of statusTabs" [ngClass]="{'active': activeStatusTab === tab.value}">
                <a href="javascript:void(0)" (click)="setStatusTab(tab.value)">{{ tab.label }}</a>
              </li>
            </ul>
          </div>
          <div class="list table-responsive">
            <ng-container *ngIf="isLoading; else loadedContent">
              <div class="empty-state">
                <h4>Loading Taxi Fleet Operators...</h4>
              </div>
            </ng-container>
            <ng-template #loadedContent>
            <ng-container *ngIf="listError; else listContent">
              <div class="empty-state">
                <img src="../../../../assets/okito/images/empty.svg" alt="">
                <h4>Unable to load Taxi Fleet Operators.</h4>
                <small>{{ listError }}</small>
              </div>
            </ng-container>
            <ng-template #listContent>
              <ng-container *ngIf="hasOperators">
                <table>
                  <thead>
                    <tr>
                      <th>Taxi Fleet Operator</th>
                      <th>Vehicles</th>
                      <th>Active Drivers</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let operator of operatorList">
                      <td>{{ operator.operatorName }}</td>
                      <td>{{ getVehicleCount(operator) }}</td>
                      <td>{{ operator.activeDriverCount }}</td>
                      <td>
                        <span class="stat" [ngClass]="getStatusClass(operator.status)">
                          {{ getStatusLabel(operator.status) }}
                        </span>
                      </td>
                      <td>
                        <a [routerLink]="['/admin/taxi-fleet', operator.fleetId]" style="cursor: pointer;">View Details</a>
                        |
                        <a
                          [routerLink]="['/admin/taxi-fleet', operator.fleetId]"
                          [queryParams]="{ tab: 'registry' }"
                          style="cursor: pointer;">View Registry</a>
                        <ng-container *ngIf="canDeactivateOperator(operator.status)">
                          |
                          <a
                            href="#"
                            style="cursor: pointer;"
                            (click)="$event.preventDefault(); openDeactivateModal(operator, deactivateModal)">
                            Deactivate
                          </a>
                        </ng-container>
                        <ng-container *ngIf="canActivateOperator(operator.status)">
                          |
                          <a
                            href="#"
                            style="cursor: pointer;"
                            (click)="$event.preventDefault(); openActivateModal(operator, activateModal)">
                            Activate
                          </a>
                        </ng-container>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </ng-container>
              <div class="empty-state" *ngIf="!hasOperators && isSearchNoResults">
                <img src="../../../../assets/okito/images/empty-search.svg" alt="">
                <h4>No Taxi Fleet Operators match your search.</h4>
                <small>Try changing your filters.</small>
              </div>
              <div class="empty-state" *ngIf="!hasOperators && !isSearchNoResults">
                <img src="../../../../assets/okito/images/empty.svg" alt="">
                <h4>No Taxi Fleet Operators yet.</h4>
                <small>Add a Taxi Fleet Operator to get started.</small>
                <a [routerLink]="['/admin/taxi-fleet/create']" class="btn btn-sm btn-default mt-2">Add Taxi Fleet Operator</a>
              </div>
            </ng-template>
            </ng-template>
          </div>
          <div class="list-footer" *ngIf="hasOperators || isSearchNoResults">
            <div class="pager">
              <button (click)="nextPrev('prev')" [disabled]="disableActionBtns.prev || isLoading">
                <img src="../../../../assets/okito/images/icons/prev.svg" alt="Previous">
              </button>
              <button (click)="nextPrev('next')" [disabled]="disableActionBtns.next || isLoading">
                <img src="../../../../assets/okito/images/icons/next.svg" alt="Next">
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #updateStatusModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Update Fleet Status</h5>
    <button type="button" class="btn-close" aria-label="Close" [disabled]="isUpdatingStatus" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <p class="mb-3" *ngIf="selectedOperator">
      Updating status for <strong>{{ selectedOperator.operatorName }}</strong>
    </p>
    <div class="form-item" style="margin-bottom: 16px;">
      <label class="form-label">Status</label>
      <select
        class="form-select"
        [(ngModel)]="selectedStatus"
        name="selectedStatus"
        [disabled]="isUpdatingStatus"
        (ngModelChange)="onStatusChange()">
        <option *ngFor="let option of statusOptions" [ngValue]="option.value">
          {{ option.label }}
        </option>
      </select>
    </div>

    <div class="form-item" *ngIf="isDeclineSelected">
      <label class="form-label">Decline Remarks</label>
      <textarea
        class="form-control"
        rows="3"
        name="declineRemarks"
        placeholder="Enter reason for declining"
        [(ngModel)]="declineRemarks"
        [disabled]="isUpdatingStatus">
      </textarea>
    </div>

    <div class="form-level-error" *ngIf="statusFormError" style="margin-top: 16px;">
      <i class="fa fa-exclamation-circle"></i> {{ statusFormError }}
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline" [disabled]="isUpdatingStatus" (click)="modal.dismiss()">Cancel</button>
    <button type="button" class="btn btn-default" [disabled]="isUpdatingStatus" (click)="confirmUpdateStatus(modal)">
      <i *ngIf="isUpdatingStatus" class="fa fa-spinner fa-spin"></i>
      {{ isUpdatingStatus ? 'Updating...' : 'Update Status' }}
    </button>
  </div>
</ng-template>


<ng-template #activateModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Activate Fleet Operator</h5>
    <button type="button" class="btn-close" aria-label="Close" [disabled]="isUpdatingStatus" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <p *ngIf="selectedOperator">
      Are you sure you want to activate <strong>{{ selectedOperator.operatorName }}</strong>?
    </p>
    <p *ngIf="!selectedOperator">Are you sure you want to activate this Fleet Operator?</p>
    <div class="form-level-error" *ngIf="statusFormError" style="margin-top: 16px;">
      <i class="fa fa-exclamation-circle"></i> {{ statusFormError }}
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline" [disabled]="isUpdatingStatus" (click)="modal.dismiss()">No, thanks</button>
    <button type="button" class="btn btn-default" [disabled]="isUpdatingStatus" (click)="confirmActivate(modal)">
      <i *ngIf="isUpdatingStatus" class="fa fa-spinner fa-spin"></i>
      {{ isUpdatingStatus ? 'Updating...' : "Yes, I'm sure" }}
    </button>
  </div>
</ng-template>

<ng-template #deactivateModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Deactivate Fleet Operator</h5>
    <button type="button" class="btn-close" aria-label="Close" [disabled]="isUpdatingStatus" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <p *ngIf="selectedOperator">
      Are you sure you want to deactivate <strong>{{ selectedOperator.operatorName }}</strong>?
    </p>
    <p *ngIf="!selectedOperator">Are you sure you want to deactivate this Fleet Operator?</p>
    <div class="form-item" style="margin-top: 16px;">
      <label class="form-label">Notes</label>
      <textarea
        class="form-control"
        rows="3"
        name="deactivateNotes"
        placeholder="Enter notes for deactivation"
        [(ngModel)]="declineRemarks"
        [disabled]="isUpdatingStatus">
      </textarea>
    </div>
    <div class="form-level-error" *ngIf="statusFormError" style="margin-top: 16px;">
      <i class="fa fa-exclamation-circle"></i> {{ statusFormError }}
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline" [disabled]="isUpdatingStatus" (click)="modal.dismiss()">No, thanks</button>
    <button type="button" class="btn btn-default" [disabled]="isUpdatingStatus" (click)="confirmDeactivate(modal)">
      <i *ngIf="isUpdatingStatus" class="fa fa-spinner fa-spin"></i>
      {{ isUpdatingStatus ? 'Updating...' : "Yes, I'm sure" }}
    </button>
  </div>
</ng-template>
